import React from 'react';

const ServiceDetailsIntro = () => {
    return (
        <section>
            <div className="stg-row stg-large-gap stg-tp-normal-gap stg-tp-column-reverse">
                <div className="stg-col-6 stg-vertical-space-between" data-unload="fade-left">
                    <div className="stg-tp-bottom-gap">
                        <h1 className="infocolors-page-title" data-split-appear="fade-up">Ignite Your Brand Identity</h1>
                        <p className="infocolors-large-text" data-appear="fade-right" data-delay="100">Welcome to the spark that ignites your brand's revolution. Our branding services aren't just about logos and colours; they're about crafting a powerful story, a visual identity, and a voice that resonates deeply with your audience and sets you apart in the digital landscape.</p>
                        <p className="infocolors-large-text infocolors-tp-normal-text" data-appear="fade-right" data-delay="200">We believe that a strong brand is the foundation for everything you do, the guiding light that attracts customers, builds loyalty, and growth.</p>
                    </div>
                    <div className="align-right" data-appear="fade-right">
                        <a href="pricing.html" className="infocolors-icon-link">
                            <div className="infocolors-icon-link-content">
                                <h6>
                                    Unleash your
                                    <br />
                                    Brand's potential
                                </h6>
                                <span className="infocolors-label">Discover Price List</span>
                            </div>
                            <div className="infocolors-icon-wrap">
                                <i className="infocolors-icon infocolors-icon-explore"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-bottom-gap-l" data-appear="fade-left" data-unload="fade-right">
                    <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/service-details.jpg" alt="Brainding" width="800" height="1200" />
                </div>
            </div>
        </section>
    );
};

export default ServiceDetailsIntro;
